import React, { useState, useCallback } from 'react'
import { LoginBox } from '@/components/auth/loginBox'
import { ValidationBoundary } from '@/components/validation'
import { Icon } from '@/components/Icon'
import { useLocalization } from '@/hooks/localization'
import context from '@/context'

const ForgotPasswordPage = React.memo(function ForgotPasswordPage () {
  const [email, setEmail] = useState('')
  const [failure, setFailure] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [waiting, setWaiting] = useState(false)
  const { localize } = useLocalization()
  const onEmailChange = useCallback(e => {
    setEmail(e.target.value || '')
  }, [])
  const onSubmit = useCallback(() => {
    setWaiting(true)
    context.api.auth.forgotPassword({ email: email })
      .then(() => setSubmitted(true))
      .catch((e) => {
        setWaiting(false)
        setFailure(getFailureText(e))
      })
  }, [email])
  if (submitted) {
    return (
      <LoginBox title='Security.ForgotPasswordConfirmationTitle' smallTitle>
        <p className='text-center'><strong>{localize('Security.ForgotPasswordConfirmation')}</strong></p>
      </LoginBox>
    )
  }
  return (
    <LoginBox title='Security.ForgotPasswordTitle' smallTitle>
      <ValidationBoundary>
        <div className='form-group'>
          <label htmlFor='UserName'>{localize('Common.EmailAddress')}</label>
          <input
            value={email} onChange={onEmailChange} disabled={waiting}
            className='form-control' placeholder={localize('Common.Email')} autoFocus
            id='Email' name='Email' type='email' />
        </div>
        {failure && <div className='alert alert-danger'>
          <div className='danger validation-summary-errors'>
            {localize(failure)}
          </div>
        </div>}
        <div className='form-group d-flex justify-content-between'>
          <button disabled={waiting} className='btn btn-primary' onClick={onSubmit}>
            <Icon name={waiting ? 'loader bx-spin' : 'log-in'} /> &nbsp; {localize('Common.Send')}</button>
        </div>
      </ValidationBoundary>
    </LoginBox>
  )
})

function getFailureText (e) {
  switch (e.response.status) {
    case 502: return 'Common.ServiceUnavailable'
    case 400: return 'Common.InvalidEmailAddress'
    default: return e.response.data.error.validationErrors[0].message
  }
}

export {
  ForgotPasswordPage
}



// WEBPACK FOOTER //
// ./src/components/auth/forgotPassword.js